import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TooltipDirective} from "./tooltip.directive";
import { ItemActionsDirective } from './item-actions.directive';
import { PreviewBoxAlignmentDirective } from './preview-box-alignment.directive';
import { ExpandableBlockDirective } from './expandable-block.directive';
import { RoughTextDirective } from './rough-text.directive';
import { SimpleAccordionSetDirective } from './simple-accordion-set.directive';
import { BorderGradientDirective } from './border-gradient.directive';
import { DraggableGridDirective } from './draggable-grid.directive';
import { RepeatFieldValidatorDirective } from './repeat-field-validator.directive';



@NgModule({
  declarations: [
    TooltipDirective,
    ItemActionsDirective,
    PreviewBoxAlignmentDirective,
    ExpandableBlockDirective,
    RoughTextDirective,
    SimpleAccordionSetDirective,
    BorderGradientDirective,
    DraggableGridDirective,
    RepeatFieldValidatorDirective
  ],
    exports: [
        TooltipDirective,
        ItemActionsDirective,
        PreviewBoxAlignmentDirective,
        ExpandableBlockDirective,
        RoughTextDirective,
        SimpleAccordionSetDirective,
        BorderGradientDirective,
        DraggableGridDirective,
        RepeatFieldValidatorDirective
    ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
